<template>
	<button 
		class="btn mr-1"
		:class="btnNextEstagio.class"
		v-if="available"
		@click="nextEstagio()">
		<i class="fas mr-2" :class="btnNextEstagio.icone"></i>
		{{ btnNextEstagio.nome }}
	</button>
</template>

<script>
	export default {
		props: ['dados'],
		data(){
			return {
				btnNextEstagio: [],
				available: true
			}
		},
		created(){
			this.setAvailable();
			this.setBtn();
		},
		methods: {
			setAvailable(){
				if(
					(this.dados.total_itens > 0) 
					&& (this.dados.estagio_id < 4) 
					&& (
						this.dados.estagio_id != 2 
						|| this.dados.itens_finalizados == this.dados.total_itens
					) 
				){
					this.available = true;
				} else {
					this.available = false;
				}
			},
			setBtn(){
				// Estagio Iniciar Produção
				if(this.dados.estagio_id == 1){
					this.btnNextEstagio = {
						class: 'btn-primary',
						nome: 'Iniciar Produção',
						icone: 'fa-wrench'
					}
				}
				// Finalizar
				if(this.dados.estagio_id == 2){
					this.btnNextEstagio = {
						class: 'btn-success',
						nome: 'Finalizar',
						icone: 'fa-check'
					}
				}
				// Entregar
				if(this.dados.estagio_id == 3){
					this.btnNextEstagio = {
						class: 'btn-success',
						nome: 'Entregue',
						icone: 'fa-car-side'
					}
				}
			},
			nextEstagio(){
				var config = {
					position: 'bottom-right',
				};
				axios.put(this.$url+'/api/adm/pedidos/next-estagio/'+this.$route.params.id)
	            .then(response => {
	            	this.$bshMessage.show(response.data.message, response.data.type, config)
	            	this.$emit('reload');
	            })
	            .catch(error => {
	            	this.$bshMessage.show(error.response.data.message, 'error')
	            });
			},
		}
	}
</script>